document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.pdpSwiper', {
        slidesOffsetAfter: 50,
        speed: 600,
        cssMode: false,
        scrollbar: {
            draggable: false,
        },
        lazy: {
            loadPrevNext: true,
            loadOnTransitionStart: true,
        },
        slidesPerView: 2.5,
        spaceBetween: 10,
        loop: false,
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            1000: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
    });

    // Hide YouTube iframes by default
    document.querySelectorAll('.youtube-iframe').forEach((e) => {
        e.style.opacity = 0;
        e.style.pointerEvents = 'none';
        e.style.zIndex = 1;
    });

    function pauseAllVideos() {
        document.querySelectorAll('.youtube-iframe iframe').forEach((iframe) => {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
    }

    document.querySelectorAll('.video-play-link').forEach((link) => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            pauseAllVideos();
            link.style.display = 'none';
            const videoId = this.dataset.videoId;
            const wrapper = this.closest('.video-wrapper');
            const container = wrapper.querySelector('.youtube-iframe');
            container.style.opacity = 1;
            container.style.pointerEvents = 'all';
            container.style.zIndex = 1;

            if (!container.querySelector('iframe')) {
                const iframe = document.createElement('iframe');
                iframe.setAttribute(
                    'src',
                    `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&showinfo=0&controls=0&rel=0&modestbranding=1&playsinline=1`
                );
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allowfullscreen', '');
                iframe.setAttribute(
                    'allow',
                    'autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                );
                container.appendChild(iframe);
            }

            wrapper.classList.add('playing');
        });
    });
});